import React from 'react'
import { CMSLink } from '@/components/Link'

interface LinkItem {
  link: {
    type?: 'reference' | 'custom' | 'file' | 'phone' | 'email' | null
    reference?: any
    file?: any
    url?: string | null
    phone?: string | null
    email?: string | null
    label?: string | null
    openInNewTab?: boolean | null
    anchor?: string | null
  }
}

interface LinksProps {
  links: LinkItem[]
  className?: string
}

export const Links: React.FC<LinksProps> = ({ links, className }) => {
  if (!links || links.length === 0) return null

  return (
    <div className={className}>
      {links.map((linkItem, index) => {
        if (!linkItem.link) return null

        return (
          <CMSLink
            key={index}
            {...linkItem.link}
            newTab={linkItem.link.openInNewTab}
            appearance="external"
            size="md"
            externalColor="brand"
          />
        )
      })}
    </div>
  )
}
